var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.456,
    height: 337.615,
    viewBox: "0 0 156.456 337.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-19",
    transform: "translate(0.533 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6235",
    "data-name": "Path 6235",
    d: "M1181.757,349.94c1-.22,9.06,37.7,8,52.45s-8,66-8,66h-82.93s-10.37-49.85-8.52-64.95,11.7-54.8,11.7-54.8Z",
    transform: "translate(-1073.363 -131.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6236",
    "data-name": "Path 6236",
    d: "M1051.467,278.25l11.85-53.35.69-8.84s2.71-19.8,2.73-21.73c0-2.24,1.1-2.77,1.93-2.7,1.28.1,2.17,1.69,2.22,3.61,0,.66-.19,11.14-.19,11.14a25.3,25.3,0,0,1,2.06-2.81c1.57-1.94,5.22-3,9-2.86s4.76.53,4.77,2a1.849,1.849,0,0,1-.75,1.4,3.622,3.622,0,0,1-2.47.82c-6-.17-7.63,3-7.63,3l-.09,1.15s3.67-2.56,6.55-1.43a3.663,3.663,0,0,1,1.15.73,4.69,4.69,0,0,1,4,7,2,2,0,0,1-1.9,1.15,2.494,2.494,0,0,1-1.05-.66,4.313,4.313,0,0,0-.53-.4l-.7,3.21s-2,7.1-2.47,10.29l-3.24,52.91A13.139,13.139,0,0,1,1063.49,294.2c-.075,0-.149-.009-.223-.015h0a13.127,13.127,0,0,1-11.8-15.94Z",
    transform: "translate(-932.473 -131.274)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6237",
    "data-name": "Path 6237",
    d: "M1062.934,224.19a2.7,2.7,0,0,0,2.83-1.44c.61-1,.87-2.11,1.4-3.11,1.59-3,5.38-4.42,6.82-7.5.2-.43.32-1-.06-1.31s-.85-.07-1.23.14l-9.93,5.36",
    transform: "translate(-930.359 -131.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6238",
    "data-name": "Path 6238",
    d: "M1062.46,216.33a4.224,4.224,0,0,1,1-.69c.67-.41,1.66-1,2.88-1.67l4.31-2.4,1.25-.69a2.217,2.217,0,0,1,1.63-.44.941.941,0,0,1,.64.85,2.006,2.006,0,0,1-.17.91,7.435,7.435,0,0,1-.87,1.42c-1.38,1.76-3.16,2.85-4.45,4.13a8.471,8.471,0,0,0-1.58,2c-.39.69-.63,1.43-.92,2.08a4,4,0,0,1-2.32,2.43c-.81.24-1.26,0-1.24-.06a3.113,3.113,0,0,0,1.16-.17,3.859,3.859,0,0,0,2-2.38,21.982,21.982,0,0,1,.87-2.15,8.706,8.706,0,0,1,1.64-2.16c1.32-1.35,3.08-2.47,4.35-4.11a6.637,6.637,0,0,0,.79-1.28c.19-.42.17-.86-.08-.91a2.291,2.291,0,0,0-1.14.39l-1.26.67-4.37,2.28c-1.25.64-2.27,1.15-3,1.49A4.5,4.5,0,0,1,1062.46,216.33Z",
    transform: "translate(-930.055 -131.274)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6240",
    "data-name": "Path 6240",
    d: "M1068.024,194.5a11.655,11.655,0,0,0-.06,2.08v5c0,1.88,0,3.58-.07,5a11.128,11.128,0,0,0,0,2.08,9.6,9.6,0,0,0,.27-2.06c.1-1.29.18-3.07.2-5s0-3.74-.12-5A9.624,9.624,0,0,0,1068.024,194.5Z",
    transform: "translate(-929.64 -131.274)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6241",
    "data-name": "Path 6241",
    d: "M1054.315,211.52a2.526,2.526,0,0,0,.61-.23,2,2,0,0,1,1.61-.06,1,1,0,0,1,.53.88,5.508,5.508,0,0,1-.11,1.35,2.328,2.328,0,0,0,.23,1.65,2,2,0,0,0,1.59.84,2.25,2.25,0,0,0,1.64-.69,2.826,2.826,0,0,0,.79-1.45,9.188,9.188,0,0,0,0-2.68,5.352,5.352,0,0,0-.51-1.73c-.21-.38-.41-.53-.42-.51s.12.2.27.58a6,6,0,0,1,.37,1.7,9.875,9.875,0,0,1-.07,2.57,2.251,2.251,0,0,1-2.05,1.8,1.6,1.6,0,0,1-1.26-.66,2,2,0,0,1-.19-1.37,5.919,5.919,0,0,0,.07-1.45,1.31,1.31,0,0,0-.74-1.09,2,2,0,0,0-1.81.18C1054.485,211.35,1054.3,211.5,1054.315,211.52Z",
    transform: "translate(-909.041 -131.274)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6243",
    "data-name": "Path 6243",
    d: "M1067.822,221.86a1.827,1.827,0,0,0-1,0,3.878,3.878,0,0,0-2.19,1.29l.35.11a11.029,11.029,0,0,0-.22-1.4,9.012,9.012,0,0,0-2.11-4.39,22.929,22.929,0,0,1,1.71,4.48c.1.47.17.93.22,1.35l.06.47.29-.36a4.063,4.063,0,0,1,2-1.31A7.643,7.643,0,0,0,1067.822,221.86Z",
    transform: "translate(-923.898 -131.274)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6245",
    "data-name": "Path 6245",
    d: "M1141.776,232.94c-4.34,0-14.77,12.33-16.59,31.06-.83,8.58-5.13,43.71-7.21,60.6a16.851,16.851,0,0,0,6.86,15.7c11.23,8.15,33.7,21,63.6,20.62l18.14-15.19-58.8-24.73v-1.34l-2.56-2.81,7.34-45S1159.376,232.94,1141.776,232.94Z",
    transform: "translate(-1117.852 -131.274)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6246",
    "data-name": "Path 6246",
    d: "M1154.828,153.79c-.22,6.09-8.33,9.77-8.23,15.86,0,2.62,1.67,5,2,7.56.43,3.48-1.52,6.77-2.24,10.21-1.49,7.09,2.63,14.56,8.74,18.44s13.79,4.62,21,3.63",
    transform: "translate(-1115.574 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6247",
    "data-name": "Path 6247",
    d: "M1133.648,152.3c-.24,3.27,1.92,6.18,4.09,8.63s4.6,5,5.07,8.25c.83,5.75-4.8,11.08-3.64,16.77.63,3.05,3.12,5.5,3.57,8.58s-1.17,5.89-3.15,8.16-4.27,1.93-6,4.38a24.541,24.541,0,0,1-7.59,6.75c-6.31,3.45-13.87-1.54-16.91-2.44",
    transform: "translate(-1045.404 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6248",
    "data-name": "Path 6248",
    d: "M1119.159,157.29c-.08-3,2.66-5.25,5.42-6.33s5.82-1.5,8.28-3.15c2.18-1.47,3.64-3.75,5.48-5.62a18.241,18.241,0,0,1,30.71,8.37c1.06,4.22.34,9.21-3,12-3.86,3.26-9.58,2.53-14.52,1.52s-10.55-2-14.68.9c-2.49,1.75-3.92,4.6-5.44,7.23s-3.43,5.33-6.31,6.32-6.79-.72-6.9-3.76",
    transform: "translate(-1081.124 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6249",
    "data-name": "Path 6249",
    d: "M1147.517,226.31c0-6.8.08-13.43.08-13.39s10.8-1.82,13-15.92c1.09-7,.72-18.5.1-27.9-.55-8.45-6.17-18.81-14.6-17.9l-26.29,6.7a5,5,0,0,0-4.43,5h0l2.41,63.84a14.86,14.86,0,0,0,15.15,14.3h0A14.86,14.86,0,0,0,1147.517,226.31Z",
    transform: "translate(-1070.093 -131.274)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6250",
    "data-name": "Path 6250",
    d: "M1124.042,177.16a1.82,1.82,0,0,1-1.74,1.83,1.73,1.73,0,0,1-1.867-1.582l0-.048a1.82,1.82,0,0,1,1.74-1.83,1.74,1.74,0,0,1,1.868,1.6Z",
    transform: "translate(-1037.897 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6251",
    "data-name": "Path 6251",
    d: "M1125.6,175.09c-.22.23-1.59-.78-3.54-.77s-3.37,1-3.58.75.13-.53.75-1a4.905,4.905,0,0,1,2.86-.9,4.792,4.792,0,0,1,2.82.91C1125.505,174.56,1125.705,175,1125.6,175.09Z",
    transform: "translate(-1037.461 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6252",
    "data-name": "Path 6252",
    d: "M1142.932,177.65a1.8,1.8,0,0,1-1.74,1.82,1.73,1.73,0,0,1-1.867-1.581l0-.039a1.82,1.82,0,0,1,1.74-1.83,1.729,1.729,0,0,1,1.866,1.582Z",
    transform: "translate(-1075.678 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6253",
    "data-name": "Path 6253",
    d: "M1144.716,175.49c-.22.24-1.59-.77-3.54-.76s-3.37,1-3.58.75.12-.54.75-1a5,5,0,0,1,2.86-.89,4.8,4.8,0,0,1,2.82.9C1144.626,175,1144.826,175.39,1144.716,175.49Z",
    transform: "translate(-1075.702 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M1126.521,189.9a12.859,12.859,0,0,1,3.16-.57c.5-.06,1-.16,1.05-.49a2.528,2.528,0,0,0-.33-1.48l-1.48-3.78c-2.05-5.38-3.54-9.8-3.32-9.88s2.06,4.21,4.11,9.59l1.41,3.81a2.861,2.861,0,0,1,.22,1.9,1.229,1.229,0,0,1-.82.73,3.061,3.061,0,0,1-.84.12A12.707,12.707,0,0,1,1126.521,189.9Z",
    transform: "translate(-1050.417 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6255",
    "data-name": "Path 6255",
    d: "M1147.962,212.92a35.911,35.911,0,0,1-18.89-5c.16,0,5.2,9.79,18.71,8.32Z",
    transform: "translate(-1070.458 -131.274)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6256",
    "data-name": "Path 6256",
    d: "M1136.881,194.59a3.492,3.492,0,0,0-3.14-1.29,3.179,3.179,0,0,0-2.21,1.19,2,2,0,0,0-.15,2.32,2.371,2.371,0,0,0,2.55.64,7.335,7.335,0,0,0,2.48-1.45,2.208,2.208,0,0,0,.56-.58.632.632,0,0,0,0-.72",
    transform: "translate(-1061.586 -131.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6257",
    "data-name": "Path 6257",
    d: "M1130.292,191.26c.32,0,.33,2.09,2.14,3.59s4.06,1.26,4.07,1.55c0,.13-.5.41-1.45.44a5.257,5.257,0,0,1-3.4-1.18,4.559,4.559,0,0,1-1.65-3C1129.912,191.77,1130.152,191.25,1130.292,191.26Z",
    transform: "translate(-1059.907 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6258",
    "data-name": "Path 6258",
    d: "M1145.53,172.09c-.19.52-2.13.28-4.41.56s-4.13.9-4.44.43c-.13-.23.19-.72.93-1.24a7.81,7.81,0,0,1,6.74-.76C1145.15,171.42,1145.53,171.83,1145.53,172.09Z",
    transform: "translate(-1075.606 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6259",
    "data-name": "Path 6259",
    d: "M1125.744,169.46c-.35.44-1.69,0-3.3,0s-3,.3-3.29-.16c-.14-.22.08-.67.67-1.09a4.643,4.643,0,0,1,2.68-.73,4.542,4.542,0,0,1,2.63.89C1125.7,168.79,1125.894,169.24,1125.744,169.46Z",
    transform: "translate(-1038.329 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6260",
    "data-name": "Path 6260",
    d: "M1130.478,205.06c3.88.78,4.22-1.19,7.12-3.88a12.722,12.722,0,0,0,3.89-10.74c-.43-3.47-2.3-7-1.1-10.26,1.59-4.34,7.66-5.67,9.27-10,.94-2.51.1-5.45,1.16-7.92,1-2.31,3.43-3.65,5.8-4.5s4.92-1.45,6.91-3,3.23-4.47,1.95-6.64a133.249,133.249,0,0,0-30.8,7.49c-2.31.86-4.72,1.89-6.08,3.93s-1.37,5-1.25,7.56l1.77,38",
    transform: "translate(-1086.724 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6261",
    "data-name": "Path 6261",
    d: "M1190.08,176.3a10.82,10.82,0,0,0-20.47-3.74c-2,4-1.28,8.82.55,12.87,2.17,4.8,6.62,9.19,11.89,8.95,5-.22,8.95-4.58,10.38-9.33s.85-9.84.26-14.77",
    transform: "translate(-1155.155 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6262",
    "data-name": "Path 6262",
    d: "M1175.73,195.61a2.415,2.415,0,0,1-.73-.82,6.887,6.887,0,0,1-1.06-2.82,13.848,13.848,0,0,1,.13-4.45c.29-1.66.85-3.4,1.25-5.24a13.072,13.072,0,0,0,.31-5.22,39.609,39.609,0,0,0-1.35-4.14,5.3,5.3,0,0,1-.08-3,1.828,1.828,0,0,1,.54-1c.05,0-.17.36-.31,1a5.577,5.577,0,0,0,.27,2.83,35.02,35.02,0,0,1,1.49,4.16,13.082,13.082,0,0,1-.26,5.46c-.42,1.88-1,3.61-1.3,5.21a13.8,13.8,0,0,0-.25,4.29A8.868,8.868,0,0,0,1175.73,195.61Z",
    transform: "translate(-1143.605 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6263",
    "data-name": "Path 6263",
    d: "M1192.982,178.68a6.8,6.8,0,0,1-2.16,2.12,12.359,12.359,0,0,1-13.93.24,6.789,6.789,0,0,1-2.24-2c.08-.08.88.76,2.47,1.67a12.871,12.871,0,0,0,13.46-.24C1192.122,179.47,1192.9,178.61,1192.982,178.68Z",
    transform: "translate(-1161.058 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6264",
    "data-name": "Path 6264",
    d: "M1189.272,180.89a6.481,6.481,0,0,1-1.19,2.21,15.444,15.444,0,0,1-10.22,6.15,6.313,6.313,0,0,1-2.51,0,24.256,24.256,0,0,1,2.44-.44,18.17,18.17,0,0,0,5.48-2.15,17.685,17.685,0,0,0,4.46-3.83C1188.7,181.67,1189.182,180.84,1189.272,180.89Z",
    transform: "translate(-1158.048 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6265",
    "data-name": "Path 6265",
    d: "M1129.139,200.33a.787.787,0,0,1-.16-.18,5.068,5.068,0,0,1-.38-.56,7.233,7.233,0,0,1-.93-2.47,8.622,8.622,0,0,1,.22-4.16,8,8,0,0,1,3.28-4.41c1.68-1.18,3.85-2,5.24-3.88a4.213,4.213,0,0,0,.76-3.31,19.143,19.143,0,0,0-1.22-3.65,10.519,10.519,0,0,1,.18-8.42,9.18,9.18,0,0,1,2.86-3.55,11.136,11.136,0,0,1,4.32-1.8c1.53-.34,3.05-.55,4.46-1a8.713,8.713,0,0,0,3.74-2.05,6.134,6.134,0,0,0,1.62-3.69,30.88,30.88,0,0,1,.67-4.1,13.991,13.991,0,0,1,3.8-6.67,11.121,11.121,0,0,1,6-3,9,9,0,0,1,5.45.82,8.664,8.664,0,0,1,3.14,2.75,7.363,7.363,0,0,1,1.1,2.39,3.645,3.645,0,0,1,.14.91,9,9,0,0,0-1.44-3.16,8.459,8.459,0,0,0-3.11-2.56,8.629,8.629,0,0,0-5.22-.7,10.735,10.735,0,0,0-5.7,2.91,13.674,13.674,0,0,0-3.61,6.44,30.886,30.886,0,0,0-.63,4,6.843,6.843,0,0,1-1.78,4,9.188,9.188,0,0,1-4,2.21c-1.48.45-3,.65-4.5,1a10.738,10.738,0,0,0-4.1,1.68,8.589,8.589,0,0,0-2.67,3.32,9.93,9.93,0,0,0-.2,7.95,19.459,19.459,0,0,1,1.23,3.78,4.772,4.772,0,0,1-.89,3.7c-1.54,2-3.78,2.81-5.4,3.93a7.637,7.637,0,0,0-3.2,4.16,8.665,8.665,0,0,0-.32,4A9.471,9.471,0,0,0,1129.139,200.33Z",
    transform: "translate(-1094.365 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6266",
    "data-name": "Path 6266",
    d: "M1126.239,161a1.532,1.532,0,0,1-.17-.65,3,3,0,0,1,.47-1.87,4.787,4.787,0,0,1,2.35-1.95,7.425,7.425,0,0,1,4.05-.13c1.48.28,3,.87,4.69,1.19a6.219,6.219,0,0,0,5.1-.8c1.49-1.14,2.24-3.11,3-5.07a21.217,21.217,0,0,1,3.26-5.81,19.55,19.55,0,0,1,10.67-6.9,11.236,11.236,0,0,1,5.63.15,8.709,8.709,0,0,1,4.16,2.64,6.51,6.51,0,0,1,1.1,6.75,4.829,4.829,0,0,1-1.06,1.61,2.387,2.387,0,0,1-.52.43,7.176,7.176,0,0,0,1.36-2.13,6.272,6.272,0,0,0,.34-2.89,6.2,6.2,0,0,0-1.55-3.49,8.373,8.373,0,0,0-3.94-2.46,10.764,10.764,0,0,0-5.36-.08,19.1,19.1,0,0,0-10.3,6.73,20.528,20.528,0,0,0-3.18,5.64c-.78,2-1.55,4-3.24,5.31a5.432,5.432,0,0,1-2.78,1,9.274,9.274,0,0,1-2.76-.19c-1.74-.37-3.25-1-4.68-1.27a7.094,7.094,0,0,0-3.84,0,4.6,4.6,0,0,0-2.27,1.75,3.126,3.126,0,0,0-.55,1.74C1126.189,160.74,1126.279,161,1126.239,161Z",
    transform: "translate(-1090.525 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6267",
    "data-name": "Path 6267",
    d: "M1056.552,233.14l25-6.36h29.8s15.45.89,24,8.48a18.886,18.886,0,0,1,4.69,7.67l13.24,30.31,6.8-38,23.78,3.38-3.8,65.38a32.132,32.132,0,0,1-25.3,28.24L1141.212,317c-1.57,12.41-2.95,23.05-3.09,22.91-.33-.33-74.08-4.8-74.08-4.8l7.47-25.24-5.172-26.524",
    transform: "translate(-1033.838 -131.274)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6268",
    "data-name": "Path 6268",
    d: "M1055.264,148.5a17.05,17.05,0,1,1,24.48,15.17v4.3l-14.94.16s-.12-2.42-.17-4.57A17,17,0,0,1,1055.264,148.5Z",
    transform: "translate(-938.05 -131.274)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M1070.624,168a1.883,1.883,0,0,0,0-.21l-.07-.61c-.08-.54-.18-1.34-.34-2.36s-.38-2.27-.72-3.7a25.628,25.628,0,0,0-1.6-4.73,16.478,16.478,0,0,0-1.42-2.53,3.2,3.2,0,0,0-1.18-1,1.781,1.781,0,0,0-1.62.07,1.19,1.19,0,0,0-.45,1.56,2.458,2.458,0,0,0,1.33,1.12,4.663,4.663,0,0,0,3.54-.29,4.738,4.738,0,0,0,2.38-2.87,3.656,3.656,0,0,0,.08-2,1.541,1.541,0,0,0-1.56-1.17,1.119,1.119,0,0,0-.87.61,1.6,1.6,0,0,0-.12,1.06,3.36,3.36,0,0,0,1.21,1.68,5.139,5.139,0,0,0,4,1.11,4.422,4.422,0,0,0,3.27-2.49,2.625,2.625,0,0,0,.1-2.07,1.341,1.341,0,0,0-.76-.75,1.281,1.281,0,0,0-1.05.11,1.733,1.733,0,0,0-.71.76,2.434,2.434,0,0,0-.25,1,4.922,4.922,0,0,0,.28,1.95,5.08,5.08,0,0,0,2.43,2.83,5.137,5.137,0,0,0,3.53.45,2.67,2.67,0,0,0,1.53-.83,1.32,1.32,0,0,0,.08-1.64,1.134,1.134,0,0,0-.77-.37,1.471,1.471,0,0,0-.81.17,2.4,2.4,0,0,0-1,1.18c-.42.93-.76,1.83-1.1,2.69-1.33,3.45-2.26,6.29-2.89,8.26-.31,1-.54,1.75-.7,2.28l-.17.59a1.375,1.375,0,0,0-.05.2,1.438,1.438,0,0,0,.07-.19c.05-.14.11-.34.19-.59.17-.53.42-1.29.74-2.26.65-2,1.61-4.8,2.95-8.24.34-.85.69-1.76,1.1-2.67a2.281,2.281,0,0,1,1-1.1,1.02,1.02,0,0,1,1.29,1.58,2.534,2.534,0,0,1-1.43.76,4.938,4.938,0,0,1-3.4-.44,4.889,4.889,0,0,1-2.33-2.73,4.709,4.709,0,0,1-.27-1.86,1.848,1.848,0,0,1,.86-1.58,1.051,1.051,0,0,1,.88-.09,1.1,1.1,0,0,1,.64.63,2.381,2.381,0,0,1-.1,1.9,4.2,4.2,0,0,1-3.11,2.37,4.851,4.851,0,0,1-3.82-1.06,3.167,3.167,0,0,1-1.15-1.57,1.3,1.3,0,0,1,.11-.91.872.872,0,0,1,.7-.5,1.149,1.149,0,0,1,.85.26,1.5,1.5,0,0,1,.49.76,3.328,3.328,0,0,1-.07,1.85,4.6,4.6,0,0,1-2.28,2.76,4.463,4.463,0,0,1-3.39.28,2.223,2.223,0,0,1-1.23-1,1,1,0,0,1,.38-1.33,1.6,1.6,0,0,1,1.46-.07,3.113,3.113,0,0,1,1.12,1,16.671,16.671,0,0,1,1.42,2.51,25.737,25.737,0,0,1,1.62,4.69c.35,1.42.57,2.67.75,3.68s.29,1.81.37,2.35a3.2,3.2,0,0,0,.1.61C1070.661,167.906,1070.641,167.952,1070.624,168Z",
    transform: "translate(-938.429 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6270",
    "data-name": "Path 6270",
    d: "M1065.872,170.88l12.83-.13a1,1,0,0,0,.95-1h0a1,1,0,0,0-1-1l-12.78.25a1,1,0,0,0-1,1h0A1,1,0,0,0,1065.872,170.88Z",
    transform: "translate(-937.947 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6271",
    "data-name": "Path 6271",
    d: "M1065.764,171.72l12.82-.13a1,1,0,1,1,0,1.92h-1.41l-1.83,3.57a1.25,1.25,0,0,1-1.09.68l-4.59.05a1.221,1.221,0,0,1-1.1-.67l-1.86-3.52h-.95a1,1,0,1,1,0-1.93Z",
    transform: "translate(-937.78 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3255",
    "data-name": "Group 3255",
    transform: "translate(137.982 3.073)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6272",
    "data-name": "Path 6272",
    d: "M1064.324,137.34a12.823,12.823,0,0,0-3.44-2.23,9.127,9.127,0,0,0-2.63-.74c-.65-.06-1,0-1.05.15-.07.31,1.23.75,3,1.9a14,14,0,0,1,6.54,13.7c-.22,2.08-.69,3.37-.4,3.51.12.06.41-.18.77-.72a9.233,9.233,0,0,0,1.03-2.51,12.677,12.677,0,0,0,.43-4.08,13.353,13.353,0,0,0-1.24-4.92",
    transform: "translate(-1057.201 -134.347)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3256",
    "data-name": "Group 3256",
    transform: "translate(131.754 1.924)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6273",
    "data-name": "Path 6273",
    d: "M1072.682,135.29c1.08,0,2-.32,2.14-.9a.962.962,0,0,0-.55-.81,3.231,3.231,0,0,0-1.62-.38,3.129,3.129,0,0,0-1.61.43c-.38.24-.58.55-.52.83",
    transform: "translate(-1070.512 -133.199)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6274",
    "data-name": "Path 6274",
    d: "M1069.442,177.47s.33-.12.88-.28a6.87,6.87,0,0,1,2.17-.3,7.1,7.1,0,0,1,2.16.38c.54.18.85.34.87.31a2.588,2.588,0,0,0-.82-.45,6.094,6.094,0,0,0-2.21-.45,6.208,6.208,0,0,0-2.18.32A2.75,2.75,0,0,0,1069.442,177.47Z",
    transform: "translate(-938.388 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M1067.292,173.68c0,.06,2.32.08,5.18,0s5.18-.1,5.18-.16-2.32-.08-5.19,0S1067.292,173.62,1067.292,173.68Z",
    transform: "translate(-938.368 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M1068.172,175.2a9,9,0,0,0,1.27.11c.78,0,1.86.08,3.06.08s2.28,0,3.06-.06a7.025,7.025,0,0,0,1.27-.1,7.7,7.7,0,0,0-1.27,0h-6.12A7.924,7.924,0,0,0,1068.172,175.2Z",
    transform: "translate(-938.428 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M1103.54,291a4.159,4.159,0,0,0,.75-.93,10.231,10.231,0,0,0,1.33-3,18.522,18.522,0,0,0-.63-10.59c-1.34-4-3.09-7.31-4.07-9.84-.5-1.26-.87-2.3-1.1-3a5.213,5.213,0,0,0-.4-1.11,5.045,5.045,0,0,0,.2,1.17,25.5,25.5,0,0,0,1,3.09c.9,2.58,2.6,6,3.92,9.87a19.243,19.243,0,0,1,.77,10.34A15.628,15.628,0,0,1,1103.54,291Z",
    transform: "translate(-998.956 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M1179.23,265.17a1.589,1.589,0,0,0-.14.51c-.08.4-.18.89-.31,1.49-.25,1.38-.59,3.24-1,5.51-.83,4.66-1.94,11.1-3.1,18.23s-2.15,13.59-2.79,18.28c-.32,2.34-.55,4.24-.7,5.56-.05.61-.09,1.11-.13,1.52a2.139,2.139,0,0,0,0,.53,1.717,1.717,0,0,0,.12-.52c.06-.4.13-.9.23-1.5.21-1.39.5-3.26.86-5.54.76-4.74,1.79-11.15,2.94-18.25s2.18-13.51,2.94-18.24c.35-2.29.64-4.16.85-5.54.09-.61.16-1.11.21-1.51A2.134,2.134,0,0,0,1179.23,265.17Z",
    transform: "translate(-1143.706 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M1087.6,292a19.415,19.415,0,0,0-.17-2.78c-.15-1.72-.32-4.08-.39-6.7s0-5,0-6.71a17.337,17.337,0,0,0,0-2.79,12.516,12.516,0,0,0-.39,2.77,60.908,60.908,0,0,0-.19,6.74,61.638,61.638,0,0,0,.54,6.73A12.362,12.362,0,0,0,1087.6,292Z",
    transform: "translate(-967.469 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6280",
    "data-name": "Path 6280",
    d: "M1179.088,323.44c.08,0,.23-.66.71-1.63a8.663,8.663,0,0,1,2.64-3.22,8.992,8.992,0,0,1,3.86-1.6c1.07-.16,1.76-.11,1.77-.19a3.624,3.624,0,0,0-1.82-.17,8,8,0,0,0-6.79,5A3.578,3.578,0,0,0,1179.088,323.44Z",
    transform: "translate(-1160.574 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6281",
    "data-name": "Path 6281",
    d: "M1176.522,326.39a24.419,24.419,0,0,1,2.6-3.25,22.962,22.962,0,0,1,3.45-2.33,8,8,0,0,0-6.05,5.58Z",
    transform: "translate(-1152.518 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6282",
    "data-name": "Path 6282",
    d: "M1176.681,326.41c.05-.14-2.79-1.3-6.24-2.83s-6.22-2.85-6.29-2.72a32.243,32.243,0,0,0,6.08,3.2A33.618,33.618,0,0,0,1176.681,326.41Z",
    transform: "translate(-1134.257 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6283",
    "data-name": "Path 6283",
    d: "M1189.852,284.25s-14.36,68.39-14.36,67.49-72.46,3.11-85.43,3.68l-2.7-.66-20.46-18.83,23.53-1.93,8.42-48.13Z",
    transform: "translate(-1050.178 -131.274)",
    fill: "#e0e0e0",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M1169.392,285.91c-.14,0-2.83,15.38-6,34.39s-5.63,34.44-5.49,34.46,2.83-15.36,6-34.38S1169.532,285.94,1169.392,285.91Z",
    transform: "translate(-1120.718 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6285",
    "data-name": "Path 6285",
    d: "M1164.01,286a3.726,3.726,0,0,0,.51.51,13.509,13.509,0,0,1,1.5,1.42c.25.34.59.79.41,1.27a13.948,13.948,0,0,0-.34,1.77c-.22,1.27-.47,2.71-.75,4.3-1.09,6.42-2.59,15.21-4.24,24.91s-3,18.51-4.08,24.94c-.49,3.15-.89,5.72-1.18,7.57-.12.85-.22,1.53-.3,2.06a3.226,3.226,0,0,0-.06.72,6.146,6.146,0,0,0,.17-.71q.15-.761.39-2c.33-1.84.78-4.4,1.34-7.54,1.09-6.43,2.59-15.21,4.24-24.92s3-18.5,4.08-24.93c.25-1.59.48-3,.68-4.31.11-.63.17-1.24.29-1.76a1.621,1.621,0,0,0-.49-1.46,12.207,12.207,0,0,0-1.59-1.37A6.356,6.356,0,0,0,1164.01,286Z",
    transform: "translate(-1115.595 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6286",
    "data-name": "Path 6286",
    d: "M1067.652,288.44a5.513,5.513,0,0,0,.89,0h2.56l9.41-.13,31.06-.54,31.06-.52,9.41-.15,2.56-.05a5.225,5.225,0,0,0,.91-.05s-.31,0-.89-.05h-11.98c-7.95,0-18.93.15-31.06.36s-23.11.48-31.06.7l-9.41.3-2.55.11A7.667,7.667,0,0,0,1067.652,288.44Z",
    transform: "translate(-1016.587 -131.274)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6287",
    "data-name": "Path 6287",
    d: "M1184.762,336a8.72,8.72,0,0,0-1.39,0l-3.8.15c-3.22.15-7.68.39-12.67.7h-.64l.49.42c.29.25.6.52.92.78,4,3.42,7.67,6.48,10.34,8.68l3.17,2.59a7.229,7.229,0,0,0,1.21.89,8.665,8.665,0,0,0-1.08-1l-3.06-2.72c-2.61-2.27-6.23-5.38-10.24-8.79-.32-.27-.63-.54-.93-.78l-.15.45c5-.31,9.45-.61,12.66-.85l3.79-.32A6.5,6.5,0,0,0,1184.762,336Z",
    transform: "translate(-1144.448 -131.275)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6288",
    "data-name": "Path 6288",
    d: "M1137.152,353.84h0l.93-11.13a3.47,3.47,0,0,0-4,3.58v-6.9s-4.24-.93-5.17,4.64a39.7,39.7,0,0,1-2.25,8.58l-2.26,1.23,2.14-12.84s-4.5.4-5.3,4.64a41.27,41.27,0,0,1-2,7.22l-7.12,2s4.08-3.65,3.69-4.84-.14-1.12-.93-1.29a7.526,7.526,0,0,0-3.8,1c-1.3.69-8.8,5.13-8.8,5.13v5.5s17.46,1.26,21.4.52l7.64-1.76A8.11,8.11,0,0,0,1137.152,353.84Z",
    transform: "translate(-1033.788 -131.275)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6289",
    "data-name": "Path 6289",
    d: "M1110.227,317.26a4.84,4.84,0,1,0,5.63-4.51A5.11,5.11,0,0,0,1110.227,317.26Z",
    transform: "translate(-1023.543 -131.274)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3257",
    "data-name": "Group 3257",
    transform: "translate(12.72 184.544)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6290",
    "data-name": "Path 6290",
    d: "M1193.606,316.51a12.932,12.932,0,0,0-9.09.28,9.3,9.3,0,0,0-5.53,7,4.509,4.509,0,0,0,.15,2.13,2.378,2.378,0,0,0,1.46,1.48,2.771,2.771,0,0,0,2.92-1.4,18.722,18.722,0,0,0,1.29-3.21,10.129,10.129,0,0,1,9.05-6.28l-.48.13",
    transform: "translate(-1178.922 -315.819)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6291",
    "data-name": "Path 6291",
    d: "M1162.885,230.54c-.59-1.88-.06-3.9.27-5.85s.38-4.17-.94-5.63-3.5-1.63-5.46-1.72l-24.2-1.05c-1.65-.07-3.57,0-4.6,1.26a3.527,3.527,0,0,0-.85,3c1.24,4.61.85,8.49-1,11.74",
    transform: "translate(-1082.881 -131.274)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6292",
    "data-name": "Path 6292",
    d: "M1127.352,228.23a6.89,6.89,0,0,0,1.06.89,28.861,28.861,0,0,0,3.18,2,31.081,31.081,0,0,0,11.86,3.62,27.859,27.859,0,0,0,6.87-.13,16.291,16.291,0,0,0,5.34-1.73,9.714,9.714,0,0,0,2.94-2.38,5.649,5.649,0,0,0,.6-.84,1.067,1.067,0,0,0,.16-.32,12.006,12.006,0,0,1-3.87,3.22,16.881,16.881,0,0,1-5.24,1.58,29.589,29.589,0,0,1-6.75.09,33.429,33.429,0,0,1-11.74-3.43C1128.952,229.38,1127.412,228.15,1127.352,228.23Z",
    transform: "translate(-1080.138 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6293",
    "data-name": "Path 6293",
    d: "M1140.352,234.83a13.888,13.888,0,0,0,.63-2.66c.32-1.66.73-4,1.15-6.5.21-1.26.4-2.46.58-3.59a6.473,6.473,0,0,0-.1-3,3,3,0,0,0-1.27-1.62,1.123,1.123,0,0,0-.73-.2,3.2,3.2,0,0,1,.62.37,3.008,3.008,0,0,1,1,1.56,6.375,6.375,0,0,1,0,2.85c-.19,1.12-.39,2.32-.61,3.58-.42,2.54-.77,4.84-1,6.52A14.546,14.546,0,0,0,1140.352,234.83Z",
    transform: "translate(-1076.618 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6294",
    "data-name": "Path 6294",
    d: "M1152.379,231a9.557,9.557,0,0,0,.45-2.2c.22-1.36.48-3.25.74-5.35s.42-4,.61-5.34a2,2,0,0,1,.76-1.28c.3-.21.52-.23.51-.27s-.24-.09-.62.09a2.078,2.078,0,0,0-1,1.37c-.31,1.4-.5,3.27-.78,5.37s-.46,4-.58,5.37A9.819,9.819,0,0,0,1152.379,231Z",
    transform: "translate(-1101.224 -131.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6295",
    "data-name": "Path 6295",
    d: "M1129.175,217.36a5.5,5.5,0,0,1,1.63,1.36,5.184,5.184,0,0,1,.89,2.1,10.6,10.6,0,0,1,.08,2.84c-.18,2.06-.36,3.94-.44,5.3a9.5,9.5,0,0,0,0,2.21,9.5,9.5,0,0,0,.4-2.18c.18-1.35.41-3.21.6-5.29a10.092,10.092,0,0,0-.13-3,5.168,5.168,0,0,0-1.07-2.23A2.7,2.7,0,0,0,1129.175,217.36Z",
    transform: "translate(-1054.991 -131.274)",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart2);
export default __webpack_public_path__ + "static/media/start2.0766d7b57a29bc7ab9bdb1c91550aaab.svg";
export { ForwardRef as ReactComponent };